import { Card, Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../components/ReusableComponents/title";
import "../../assets/css/accountanalysis.scss";
import HeadAndDesc from "../../components/ReusableComponents/HeadAndDesc";
import BalanceCurve from "./../../components/Charts/BalanceCurveChart";
import ProfitlossChart from "../../components/Charts/ProfitLossChart";
import FinalEvalTable from "../../components/AccountAnalysis/FinalEvalTable";
import { dollarUS } from "../../utilities/formatters";
import { fetchAccountObjectives } from "../../store/reducers/dashboardReducer";

const General = ({ data }) => {
  const { programObjectives } = useSelector((state) => state.dashboard);
  console.log(programObjectives, "accountMetricData");

  const upIcon = () => {
    return (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.25 13.9334C9.25 14.3476 9.58579 14.6834 10 14.6834C10.4142 14.6834 10.75 14.3476 10.75 13.9334H9.25ZM5.86731 9.08541C5.57573 9.37961 5.57784 9.85448 5.87204 10.1461C6.16624 10.4376 6.64111 10.4355 6.93269 10.1413L5.86731 9.08541ZM7.65806 8.34404L8.19075 8.87199L7.65806 8.34404ZM12.3419 8.34404L12.8746 7.81608V7.81608L12.3419 8.34404ZM13.0673 10.1413C13.3589 10.4355 13.8338 10.4376 14.128 10.1461C14.4222 9.85448 14.4243 9.37961 14.1327 9.08542L13.0673 10.1413ZM9.7744 6.74769L9.67957 6.00371L9.67957 6.00371L9.7744 6.74769ZM10.2256 6.74769L10.3204 6.00371L10.3204 6.00371L10.2256 6.74769ZM10.75 6.74769C10.75 6.33348 10.4142 5.99769 10 5.99769C9.58579 5.99769 9.25 6.33348 9.25 6.74769H10.75ZM18.25 10.3334C18.25 14.8897 14.5563 18.5834 10 18.5834V20.0834C15.3848 20.0834 19.75 15.7182 19.75 10.3334H18.25ZM10 18.5834C5.44365 18.5834 1.75 14.8897 1.75 10.3334H0.25C0.25 15.7182 4.61522 20.0834 10 20.0834V18.5834ZM1.75 10.3334C1.75 5.77702 5.44365 2.08337 10 2.08337V0.583374C4.61522 0.583374 0.25 4.9486 0.25 10.3334H1.75ZM10 2.08337C14.5563 2.08337 18.25 5.77702 18.25 10.3334H19.75C19.75 4.9486 15.3848 0.583374 10 0.583374V2.08337ZM10.75 13.9334V7.45337H9.25V13.9334H10.75ZM6.93269 10.1413L8.19075 8.87199L7.12537 7.81608L5.86731 9.08541L6.93269 10.1413ZM11.8092 8.87199L13.0673 10.1413L14.1327 9.08542L12.8746 7.81608L11.8092 8.87199ZM8.19075 8.87199C8.70481 8.35333 9.04654 8.01015 9.3328 7.78026C9.60723 7.55986 9.75704 7.50598 9.86923 7.49167L9.67957 6.00371C9.18035 6.06735 8.77362 6.30549 8.39356 6.61072C8.02533 6.90644 7.6146 7.32247 7.12537 7.81608L8.19075 8.87199ZM12.8746 7.81608C12.3854 7.32247 11.9747 6.90644 11.6064 6.61072C11.2264 6.3055 10.8197 6.06735 10.3204 6.00371L10.1308 7.49167C10.243 7.50598 10.3928 7.55986 10.6672 7.78026C10.9535 8.01015 11.2952 8.35333 11.8092 8.87199L12.8746 7.81608ZM9.86923 7.49168C9.95607 7.48061 10.0439 7.48061 10.1308 7.49168L10.3204 6.00371C10.1077 5.97659 9.89234 5.97659 9.67957 6.00371L9.86923 7.49168ZM10.75 7.45337V6.74769H9.25V7.45337H10.75Z"
          fill="#64C144"
        />
      </svg>
    );
  };

  const downIcon = () => {
    return (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.25 5.5C9.25 5.08579 8.91421 4.75 8.5 4.75C8.08579 4.75 7.75 5.08579 7.75 5.5H9.25ZM12.0327 9.62796C12.3243 9.33376 12.3222 8.85889 12.028 8.56731C11.7338 8.27573 11.2589 8.27784 10.9673 8.57204L12.0327 9.62796ZM10.4516 10.1578L10.9843 10.6857L10.4516 10.1578ZM6.54839 10.1578L6.01569 10.6857L6.54839 10.1578ZM6.03269 8.57204C5.74111 8.27784 5.26624 8.27573 4.97204 8.56731C4.67784 8.85889 4.67573 9.33376 4.96731 9.62796L6.03269 8.57204ZM8.688 11.4881L8.78283 12.232L8.78283 12.232L8.688 11.4881ZM8.312 11.4881L8.21717 12.232L8.21717 12.232L8.312 11.4881ZM15.25 8.5C15.25 12.2279 12.2279 15.25 8.5 15.25V16.75C13.0563 16.75 16.75 13.0563 16.75 8.5H15.25ZM8.5 15.25C4.77208 15.25 1.75 12.2279 1.75 8.5H0.25C0.25 13.0563 3.94365 16.75 8.5 16.75V15.25ZM1.75 8.5C1.75 4.77208 4.77208 1.75 8.5 1.75V0.25C3.94365 0.25 0.25 3.94365 0.25 8.5H1.75ZM8.5 1.75C12.2279 1.75 15.25 4.77208 15.25 8.5H16.75C16.75 3.94365 13.0563 0.25 8.5 0.25V1.75ZM7.75 5.5V10.9H9.25V5.5H7.75ZM10.9673 8.57204L9.91892 9.62982L10.9843 10.6857L12.0327 9.62796L10.9673 8.57204ZM7.08108 9.62982L6.03269 8.57204L4.96731 9.62796L6.01569 10.6857L7.08108 9.62982ZM9.91892 9.62982C9.48848 10.0641 9.20945 10.344 8.97773 10.5301C8.75784 10.7067 8.65441 10.7363 8.59317 10.7441L8.78283 12.232C9.2311 12.1749 9.59145 11.9611 9.91697 11.6997C10.2307 11.4478 10.5787 11.095 10.9843 10.6857L9.91892 9.62982ZM6.01569 10.6857C6.42131 11.095 6.76934 11.4478 7.08303 11.6997C7.40855 11.9611 7.7689 12.1749 8.21717 12.232L8.40683 10.7441C8.34559 10.7363 8.24216 10.7067 8.02227 10.5301C7.79055 10.344 7.51152 10.0641 7.08108 9.62982L6.01569 10.6857ZM8.59317 10.7441C8.56223 10.748 8.53111 10.75 8.5 10.75V12.25C8.59447 12.25 8.68893 12.244 8.78283 12.232L8.59317 10.7441ZM8.5 10.75C8.46889 10.75 8.43777 10.748 8.40683 10.7441L8.21717 12.232C8.31107 12.244 8.40553 12.25 8.5 12.25V10.75ZM7.75 10.9V11.5H9.25V10.9H7.75Z"
          fill="#FD504F"
        />
      </svg>
    );
  };
  const [Objectives, setObjectives] = useState(false);
  const dispatch = useDispatch();
  const HeadAndDescWrapper = (props) => {
    return (
      <Grid item xs={3}>
        <HeadAndDesc {...props} HeadAndSubClassName={"headAndDescBox"} />
      </Grid>
    );
  };
  const HeadAndDescWrapper2 = (props) => {
    return (
      <Grid
        item
        xs={12}
        paddingTop={"0px"}
        sx={{ paddingTop: "0px", width: "100%" }}
      >
        <HeadAndDesc {...props} HeadAndSubClassName={"headAndDescBox2"} />
      </Grid>
    );
  };

  useEffect(() => {
    if (data && data.Basic_info.login_id) {
      dispatch(
        fetchAccountObjectives(
          data.Basic_info.login_id,
          data.account_model.platform
        )
      )
        .then((data) => {
          setObjectives(data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [data, dispatch]);

  const StatFormatter = (status) => {
    const stat = status?.toLowerCase(); // Safely handle undefined values

    // Determine the appropriate class based on the status value
    const classList =
      stat === "success"
        ? "StatusPassed"
        : stat === "failed"
        ? "StatusFailed"
        : "StatusInProgress"; // Default to "In Progress" if status is neither success nor failed

    return classList;
  };

  console.log("Objectives", Objectives);

  return (
    <div className="general-ctn">
      <div className="general_statistic_charts">
        <div className="card-csc">
          <h2 six>Balance Curve</h2>
          {/*<BalanceCurve data={data && data.Basic_info.balance_equity_history} />*/}
          <BalanceCurve
            data={data && data?.Basic_info?.balance_equity_history}
          />
          {/* <BalanceChart PerformanceChart={data && data.Basic_info.balance_equity_history}/> */}
        </div>

        <div className="card-csc">
          <h2 six>Average profit / Average loss</h2>
          <ProfitlossChart data={data && data.general_statistics} />
        </div>
      </div>

      <div className="basic_general_wrapper">
        <div className="basic_info_wrapper">
          <h2 className="">Basic Information</h2>
          <div className="basic_info">
            <div className="basic_info_box">
              <p>Login ID</p>
              <p>{(data && data.Basic_info.login_id) || "--"}</p>
            </div>
            <div className="basic_info_box">
              <p>Account Size</p>
              <p>{(data && dollarUS(data.Basic_info.account_size)) || "--"}</p>
            </div>
            <div className="basic_info_box">
              <p>Start Date</p>
              <p>{(data && data.Basic_info.start_date) || "--"}</p>
            </div>
            <div className="basic_info_box">
              <p>End Date</p>
              <p>{(data && data.Basic_info.end_date) || "--"}</p>
            </div>
          </div>

          <h2 className="">Final Evaluation</h2>
          {/* <FinalEvalTable data={data && data} Objectives={Objectives} /> */}
          <div className="final_eval">
            {/* Max Daily Loss Section */}
            <div className="final_eval_box">
              <p>Max Daily Loss</p>
              <div className="final_eval_box_lower">
                <button
                  className={StatFormatter(
                    Objectives?.["drawdown_result"]?.["max_daily_loss"]?.[
                      "status"
                    ]
                  )}
                >
                  {Objectives &&
                    Objectives["drawdown_result"] &&
                    Objectives["drawdown_result"]["max_daily_loss"]["status"]}
                </button>
                <div>
                  <p>Result</p>
                  <p>
                    {dollarUS(
                      programObjectives?.drawdown_result?.max_daily_loss?.result
                    )}
                  </p>
                </div>
              </div>
            </div>

            {/* Minimum Trading Days Section */}
            {!!Objectives?.min_profit_days?.result &&
              Objectives?.min_profit_days?.target && (
                <div className="final_eval_box">
                  <p>{`Minimum ${programObjectives?.min_profit_days?.target} Trading Days`}</p>
                  <div className="final_eval_box_lower">
                    <button
                      className={StatFormatter(
                        Objectives?.["min_profit_days"]?.["status"]
                      )}
                    >
                      {Objectives?.min_profit_days?.status &&
                        Objectives["min_profit_days"]["status"]}
                    </button>
                    <div>
                      <p>Result</p>
                      <p>{programObjectives?.min_profit_days?.result}</p>
                    </div>
                  </div>
                </div>
              )}

            {/* Max Loss Section */}
            <div className="final_eval_box">
              <p>Max Loss</p>
              <div className="final_eval_box_lower">
                <button
                  className={StatFormatter(
                    Objectives?.["drawdown_result"]?.["max_loss"]?.["status"]
                  )}
                >
                  {Objectives &&
                    Objectives["drawdown_result"] &&
                    Objectives["drawdown_result"]["max_loss"]["status"]}
                </button>
                <div>
                  <p>Result</p>
                  <p>
                    {dollarUS(
                      programObjectives?.drawdown_result?.max_loss?.result
                    )}
                  </p>
                </div>
              </div>
            </div>

            {/* Profit Target Section */}
            <div className="final_eval_box">
              <p>Profit Target</p>
              <div className="final_eval_box_lower">
                <button
                  className={StatFormatter(Objectives?.profit_target?.status)}
                >
                  {Objectives?.profit_target?.status}
                </button>
                <div>
                  <p>Result</p>
                  <p>{dollarUS(programObjectives?.profit_target?.result)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="general_statistic">
          <h2>General Statistics</h2>
          <div className="generalStatistics_wrapper">
            <div className="general_statistic_box">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.75 6.75L10.2231 9.57238C9.22181 10.6908 8.72115 11.25 8.0625 11.25C7.40385 11.25 6.90319 10.6908 5.90188 9.57238L5.25 8.84427M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                  stroke="#F6F6F6"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>

              <HeadAndDescWrapper2
                HeadTitle="Result"
                SubTitle={
                  data &&
                  dollarUS(Number(data.general_statistics.result).toFixed(2))
                }
                SubTitleClass={
                  data && data.general_statistics.result >= 0
                    ? "Positive"
                    : "Negative"
                }
              />
            </div>
            <div className="general_statistic_box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
              >
                <path
                  d="M4.19651 10.6233L4.89225 10.3432L4.19651 10.6233ZM7.05087 13.0416L6.75113 13.7291L7.05087 13.0416ZM5.00117 11.8519L5.53597 11.3261L5.00117 11.8519ZM14.1539 10.6233L13.4581 10.3432L14.1539 10.6233ZM11.2995 13.0416L11.5993 13.7291L11.2995 13.0416ZM13.3492 11.8519L13.884 12.3777L13.3492 11.8519ZM14.2417 4.25781L13.5284 4.48957L14.2417 4.25781ZM11.834 1.85016L11.6022 2.56346L11.834 1.85016ZM4.10873 4.25781L4.82202 4.48957L4.10873 4.25781ZM6.51638 1.85016L6.74814 2.56346L6.51638 1.85016ZM1.92459 8.87205L1.469 9.46782L1.47965 9.47596L1.49059 9.48372L1.92459 8.87205ZM16.4259 8.87205L16.8599 9.48372L16.8708 9.47596L16.8815 9.46782L16.4259 8.87205ZM8.42519 16.6666C8.42519 17.0808 8.76098 17.4166 9.17519 17.4166C9.5894 17.4166 9.92519 17.0808 9.92519 16.6666H8.42519ZM12.1752 17.4166C12.5894 17.4166 12.9252 17.0808 12.9252 16.6666C12.9252 16.2524 12.5894 15.9166 12.1752 15.9166V17.4166ZM6.17519 15.9166C5.76098 15.9166 5.42519 16.2524 5.42519 16.6666C5.42519 17.0808 5.76098 17.4166 6.17519 17.4166V15.9166ZM14.3399 4.66663L13.6003 4.79122L14.3399 4.66663ZM14.5881 10.176L15.0221 10.7877L14.5881 10.176ZM3.76657 10.179L3.33257 10.7907L3.76657 10.179ZM13.6752 6.91663V7.89192H15.1752V6.91663H13.6752ZM4.67519 7.89192V6.91663H3.17519V7.89192H4.67519ZM10.9998 12.3541C10.6089 12.5245 10.236 12.6691 9.90781 12.7699C9.56865 12.8742 9.32445 12.9166 9.17519 12.9166V14.4166C9.54659 14.4166 9.9586 14.3236 10.3485 14.2037C10.7493 14.0806 11.1782 13.9126 11.5993 13.7291L10.9998 12.3541ZM9.17519 12.9166C9.02593 12.9166 8.78173 12.8742 8.44257 12.7699C8.11439 12.6691 7.74148 12.5245 7.35061 12.3541L6.75113 13.7291C7.17216 13.9126 7.60109 14.0806 8.00193 14.2037C8.39178 14.3236 8.80379 14.4166 9.17519 14.4166V12.9166ZM7.35061 12.3541C6.29645 11.8945 5.92566 11.7225 5.53597 11.3261L4.46636 12.3777C5.09537 13.0175 5.75149 13.2932 6.75113 13.7291L7.35061 12.3541ZM3.50078 10.9034C3.70162 11.4023 4.08932 11.9943 4.46636 12.3777L5.53597 11.3261C5.29756 11.0836 5.01925 10.6587 4.89225 10.3432L3.50078 10.9034ZM11.5993 13.7291C12.5989 13.2932 13.255 13.0175 13.884 12.3777L12.8144 11.3261C12.4247 11.7225 12.0539 11.8945 10.9998 12.3541L11.5993 13.7291ZM13.4581 10.3432C13.3311 10.6587 13.0528 11.0836 12.8144 11.3261L13.884 12.3777C14.2611 11.9943 14.6488 11.4023 14.8496 10.9034L13.4581 10.3432ZM9.17519 2.41663C10.6295 2.41663 11.1788 2.42588 11.6022 2.56346L12.0658 1.13687C11.3594 0.907373 10.5128 0.916626 9.17519 0.916626V2.41663ZM14.9549 4.02605C14.5098 2.65608 13.4357 1.582 12.0658 1.13687L11.6022 2.56346C12.5156 2.86021 13.2316 3.57626 13.5284 4.48957L14.9549 4.02605ZM9.17519 0.916626C7.8376 0.916626 6.99094 0.907373 6.28461 1.13687L6.74814 2.56346C7.17156 2.42588 7.72085 2.41663 9.17519 2.41663V0.916626ZM4.82202 4.48957C5.11877 3.57626 5.83483 2.86021 6.74814 2.56346L6.28461 1.13687C4.91464 1.582 3.84057 2.65608 3.39544 4.02605L4.82202 4.48957ZM4.20058 9.56734L2.3586 8.26038L1.49059 9.48372L3.33257 10.7907L4.20058 9.56734ZM2.38018 8.27628C1.16955 7.35051 1.82424 5.41663 3.34827 5.41663V3.91663C0.389807 3.91663 -0.881069 7.6707 1.469 9.46782L2.38018 8.27628ZM3.34827 5.41663H3.92529V3.91663H3.34827V5.41663ZM15.0221 10.7877L16.8599 9.48372L15.9919 8.26038L14.1541 9.56435L15.0221 10.7877ZM16.8815 9.46782C19.2316 7.6707 17.9607 3.91663 15.0022 3.91663V5.41663C16.5262 5.41663 17.1809 7.35051 15.9703 8.27628L16.8815 9.46782ZM15.0022 3.91663H14.4252V5.41663H15.0022V3.91663ZM8.42519 13.6666V16.6666H9.92519V13.6666H8.42519ZM12.1752 15.9166H6.17519V17.4166H12.1752V15.9166ZM4.67519 6.91663C4.67519 5.80519 4.67781 5.22007 4.75006 4.79122L3.2709 4.54203C3.17257 5.12567 3.17519 5.86557 3.17519 6.91663H4.67519ZM4.75006 4.79122C4.76962 4.67509 4.79352 4.5773 4.82202 4.48957L3.39544 4.02605C3.34118 4.19302 3.30098 4.36346 3.2709 4.54203L4.75006 4.79122ZM3.92529 5.41663H4.01048V3.91663H3.92529V5.41663ZM3.17519 7.89192C3.17519 9.0459 3.16789 9.85011 3.38747 10.5805L4.82396 10.1487C4.68249 9.6781 4.67519 9.13281 4.67519 7.89192H3.17519ZM3.38747 10.5805C3.42028 10.6897 3.45788 10.7968 3.50078 10.9034L4.89225 10.3432C4.86623 10.2786 4.84367 10.2142 4.82396 10.1487L3.38747 10.5805ZM13.6752 7.89192C13.6752 9.13816 13.6678 9.68295 13.5247 10.1544L14.9601 10.59C15.1826 9.85661 15.1752 9.05064 15.1752 7.89192H13.6752ZM13.5247 10.1544C13.5054 10.2179 13.4834 10.2804 13.4581 10.3432L14.8496 10.9034C14.8913 10.7999 14.9279 10.6959 14.9601 10.59L13.5247 10.1544ZM15.1752 6.91663C15.1752 5.86557 15.1778 5.12567 15.0795 4.54203L13.6003 4.79122C13.6726 5.22007 13.6752 5.80519 13.6752 6.91663H15.1752ZM15.0795 4.54203C15.0494 4.36346 15.0092 4.19302 14.9549 4.02605L13.5284 4.48957C13.5569 4.5773 13.5808 4.67509 13.6003 4.79122L15.0795 4.54203ZM14.4252 3.91663H14.3399V5.41663H14.4252V3.91663ZM14.1541 9.56435C14.087 9.61196 14.0153 9.65266 13.94 9.68584L14.5448 11.0585C14.7126 10.9846 14.8725 10.8938 15.0221 10.7877L14.1541 9.56435ZM3.33257 10.7907C3.48555 10.8992 3.65065 10.9896 3.82454 11.0599L4.38689 9.66929C4.32103 9.64266 4.25851 9.60844 4.20058 9.56734L3.33257 10.7907Z"
                  fill="#CBB300"
                />
              </svg>
              <HeadAndDescWrapper2
                HeadTitle="Win rate"
                SubTitle={
                  data && Number(data.general_statistics.win_rate).toFixed(2)
                }
                SubTitleClass={
                  data && data.general_statistics.win_rate >= 0
                    ? "Positive"
                    : "Negative"
                }
              />
            </div>
            <div className="general_statistic_box profit">
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.25 13.9334C9.25 14.3476 9.58579 14.6834 10 14.6834C10.4142 14.6834 10.75 14.3476 10.75 13.9334H9.25ZM5.86731 9.08541C5.57573 9.37961 5.57784 9.85448 5.87204 10.1461C6.16624 10.4376 6.64111 10.4355 6.93269 10.1413L5.86731 9.08541ZM7.65806 8.34404L8.19075 8.87199L7.65806 8.34404ZM12.3419 8.34404L12.8746 7.81608V7.81608L12.3419 8.34404ZM13.0673 10.1413C13.3589 10.4355 13.8338 10.4376 14.128 10.1461C14.4222 9.85448 14.4243 9.37961 14.1327 9.08542L13.0673 10.1413ZM9.7744 6.74769L9.67957 6.00371L9.67957 6.00371L9.7744 6.74769ZM10.2256 6.74769L10.3204 6.00371L10.3204 6.00371L10.2256 6.74769ZM10.75 6.74769C10.75 6.33348 10.4142 5.99769 10 5.99769C9.58579 5.99769 9.25 6.33348 9.25 6.74769H10.75ZM18.25 10.3334C18.25 14.8897 14.5563 18.5834 10 18.5834V20.0834C15.3848 20.0834 19.75 15.7182 19.75 10.3334H18.25ZM10 18.5834C5.44365 18.5834 1.75 14.8897 1.75 10.3334H0.25C0.25 15.7182 4.61522 20.0834 10 20.0834V18.5834ZM1.75 10.3334C1.75 5.77702 5.44365 2.08337 10 2.08337V0.583374C4.61522 0.583374 0.25 4.9486 0.25 10.3334H1.75ZM10 2.08337C14.5563 2.08337 18.25 5.77702 18.25 10.3334H19.75C19.75 4.9486 15.3848 0.583374 10 0.583374V2.08337ZM10.75 13.9334V7.45337H9.25V13.9334H10.75ZM6.93269 10.1413L8.19075 8.87199L7.12537 7.81608L5.86731 9.08541L6.93269 10.1413ZM11.8092 8.87199L13.0673 10.1413L14.1327 9.08542L12.8746 7.81608L11.8092 8.87199ZM8.19075 8.87199C8.70481 8.35333 9.04654 8.01015 9.3328 7.78026C9.60723 7.55986 9.75704 7.50598 9.86923 7.49167L9.67957 6.00371C9.18035 6.06735 8.77362 6.30549 8.39356 6.61072C8.02533 6.90644 7.6146 7.32247 7.12537 7.81608L8.19075 8.87199ZM12.8746 7.81608C12.3854 7.32247 11.9747 6.90644 11.6064 6.61072C11.2264 6.3055 10.8197 6.06735 10.3204 6.00371L10.1308 7.49167C10.243 7.50598 10.3928 7.55986 10.6672 7.78026C10.9535 8.01015 11.2952 8.35333 11.8092 8.87199L12.8746 7.81608ZM9.86923 7.49168C9.95607 7.48061 10.0439 7.48061 10.1308 7.49168L10.3204 6.00371C10.1077 5.97659 9.89234 5.97659 9.67957 6.00371L9.86923 7.49168ZM10.75 7.45337V6.74769H9.25V7.45337H10.75Z"
                  fill="#64C144"
                />
              </svg>
              <HeadAndDescWrapper2
                HeadTitle="Average Profit"
                SubTitle={
                  data &&
                  dollarUS(
                    data &&
                      Number(data.general_statistics.Average_profit).toFixed(2)
                  )
                }
                SubTitleClass={
                  data && data.general_statistics.Average_profit >= 0
                    ? "Positive"
                    : "Negative"
                }
              />
            </div>
            <div className="general_statistic_box profit">
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.25 13.9334C9.25 14.3476 9.58579 14.6834 10 14.6834C10.4142 14.6834 10.75 14.3476 10.75 13.9334H9.25ZM5.86731 9.08541C5.57573 9.37961 5.57784 9.85448 5.87204 10.1461C6.16624 10.4376 6.64111 10.4355 6.93269 10.1413L5.86731 9.08541ZM7.65806 8.34404L8.19075 8.87199L7.65806 8.34404ZM12.3419 8.34404L12.8746 7.81608V7.81608L12.3419 8.34404ZM13.0673 10.1413C13.3589 10.4355 13.8338 10.4376 14.128 10.1461C14.4222 9.85448 14.4243 9.37961 14.1327 9.08542L13.0673 10.1413ZM9.7744 6.74769L9.67957 6.00371L9.67957 6.00371L9.7744 6.74769ZM10.2256 6.74769L10.3204 6.00371L10.3204 6.00371L10.2256 6.74769ZM10.75 6.74769C10.75 6.33348 10.4142 5.99769 10 5.99769C9.58579 5.99769 9.25 6.33348 9.25 6.74769H10.75ZM18.25 10.3334C18.25 14.8897 14.5563 18.5834 10 18.5834V20.0834C15.3848 20.0834 19.75 15.7182 19.75 10.3334H18.25ZM10 18.5834C5.44365 18.5834 1.75 14.8897 1.75 10.3334H0.25C0.25 15.7182 4.61522 20.0834 10 20.0834V18.5834ZM1.75 10.3334C1.75 5.77702 5.44365 2.08337 10 2.08337V0.583374C4.61522 0.583374 0.25 4.9486 0.25 10.3334H1.75ZM10 2.08337C14.5563 2.08337 18.25 5.77702 18.25 10.3334H19.75C19.75 4.9486 15.3848 0.583374 10 0.583374V2.08337ZM10.75 13.9334V7.45337H9.25V13.9334H10.75ZM6.93269 10.1413L8.19075 8.87199L7.12537 7.81608L5.86731 9.08541L6.93269 10.1413ZM11.8092 8.87199L13.0673 10.1413L14.1327 9.08542L12.8746 7.81608L11.8092 8.87199ZM8.19075 8.87199C8.70481 8.35333 9.04654 8.01015 9.3328 7.78026C9.60723 7.55986 9.75704 7.50598 9.86923 7.49167L9.67957 6.00371C9.18035 6.06735 8.77362 6.30549 8.39356 6.61072C8.02533 6.90644 7.6146 7.32247 7.12537 7.81608L8.19075 8.87199ZM12.8746 7.81608C12.3854 7.32247 11.9747 6.90644 11.6064 6.61072C11.2264 6.3055 10.8197 6.06735 10.3204 6.00371L10.1308 7.49167C10.243 7.50598 10.3928 7.55986 10.6672 7.78026C10.9535 8.01015 11.2952 8.35333 11.8092 8.87199L12.8746 7.81608ZM9.86923 7.49168C9.95607 7.48061 10.0439 7.48061 10.1308 7.49168L10.3204 6.00371C10.1077 5.97659 9.89234 5.97659 9.67957 6.00371L9.86923 7.49168ZM10.75 7.45337V6.74769H9.25V7.45337H10.75Z"
                  fill="#64C144"
                />
              </svg>
              <HeadAndDescWrapper2
                HeadTitle="Max Profit"
                SubTitle={
                  data &&
                  dollarUS(
                    Number(data.general_statistics.max_profit).toFixed(2)
                  )
                }
                SubTitleClass="Positive"
              />
            </div>

            <div className="general_statistic_box loss">
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.25 5.5C9.25 5.08579 8.91421 4.75 8.5 4.75C8.08579 4.75 7.75 5.08579 7.75 5.5H9.25ZM12.0327 9.62796C12.3243 9.33376 12.3222 8.85889 12.028 8.56731C11.7338 8.27573 11.2589 8.27784 10.9673 8.57204L12.0327 9.62796ZM10.4516 10.1578L10.9843 10.6857L10.4516 10.1578ZM6.54839 10.1578L6.01569 10.6857L6.54839 10.1578ZM6.03269 8.57204C5.74111 8.27784 5.26624 8.27573 4.97204 8.56731C4.67784 8.85889 4.67573 9.33376 4.96731 9.62796L6.03269 8.57204ZM8.688 11.4881L8.78283 12.232L8.78283 12.232L8.688 11.4881ZM8.312 11.4881L8.21717 12.232L8.21717 12.232L8.312 11.4881ZM15.25 8.5C15.25 12.2279 12.2279 15.25 8.5 15.25V16.75C13.0563 16.75 16.75 13.0563 16.75 8.5H15.25ZM8.5 15.25C4.77208 15.25 1.75 12.2279 1.75 8.5H0.25C0.25 13.0563 3.94365 16.75 8.5 16.75V15.25ZM1.75 8.5C1.75 4.77208 4.77208 1.75 8.5 1.75V0.25C3.94365 0.25 0.25 3.94365 0.25 8.5H1.75ZM8.5 1.75C12.2279 1.75 15.25 4.77208 15.25 8.5H16.75C16.75 3.94365 13.0563 0.25 8.5 0.25V1.75ZM7.75 5.5V10.9H9.25V5.5H7.75ZM10.9673 8.57204L9.91892 9.62982L10.9843 10.6857L12.0327 9.62796L10.9673 8.57204ZM7.08108 9.62982L6.03269 8.57204L4.96731 9.62796L6.01569 10.6857L7.08108 9.62982ZM9.91892 9.62982C9.48848 10.0641 9.20945 10.344 8.97773 10.5301C8.75784 10.7067 8.65441 10.7363 8.59317 10.7441L8.78283 12.232C9.2311 12.1749 9.59145 11.9611 9.91697 11.6997C10.2307 11.4478 10.5787 11.095 10.9843 10.6857L9.91892 9.62982ZM6.01569 10.6857C6.42131 11.095 6.76934 11.4478 7.08303 11.6997C7.40855 11.9611 7.7689 12.1749 8.21717 12.232L8.40683 10.7441C8.34559 10.7363 8.24216 10.7067 8.02227 10.5301C7.79055 10.344 7.51152 10.0641 7.08108 9.62982L6.01569 10.6857ZM8.59317 10.7441C8.56223 10.748 8.53111 10.75 8.5 10.75V12.25C8.59447 12.25 8.68893 12.244 8.78283 12.232L8.59317 10.7441ZM8.5 10.75C8.46889 10.75 8.43777 10.748 8.40683 10.7441L8.21717 12.232C8.31107 12.244 8.40553 12.25 8.5 12.25V10.75ZM7.75 10.9V11.5H9.25V10.9H7.75Z"
                  fill="#FD504F"
                />
              </svg>
              <HeadAndDescWrapper2
                HeadTitle="Average Loss"
                SubTitle={
                  data &&
                  dollarUS(
                    Number(data.general_statistics.Average_loss).toFixed(2)
                  )
                }
                SubTitleClass="Negative"
              />
            </div>
            <div className="general_statistic_box loss">
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.25 5.5C9.25 5.08579 8.91421 4.75 8.5 4.75C8.08579 4.75 7.75 5.08579 7.75 5.5H9.25ZM12.0327 9.62796C12.3243 9.33376 12.3222 8.85889 12.028 8.56731C11.7338 8.27573 11.2589 8.27784 10.9673 8.57204L12.0327 9.62796ZM10.4516 10.1578L10.9843 10.6857L10.4516 10.1578ZM6.54839 10.1578L6.01569 10.6857L6.54839 10.1578ZM6.03269 8.57204C5.74111 8.27784 5.26624 8.27573 4.97204 8.56731C4.67784 8.85889 4.67573 9.33376 4.96731 9.62796L6.03269 8.57204ZM8.688 11.4881L8.78283 12.232L8.78283 12.232L8.688 11.4881ZM8.312 11.4881L8.21717 12.232L8.21717 12.232L8.312 11.4881ZM15.25 8.5C15.25 12.2279 12.2279 15.25 8.5 15.25V16.75C13.0563 16.75 16.75 13.0563 16.75 8.5H15.25ZM8.5 15.25C4.77208 15.25 1.75 12.2279 1.75 8.5H0.25C0.25 13.0563 3.94365 16.75 8.5 16.75V15.25ZM1.75 8.5C1.75 4.77208 4.77208 1.75 8.5 1.75V0.25C3.94365 0.25 0.25 3.94365 0.25 8.5H1.75ZM8.5 1.75C12.2279 1.75 15.25 4.77208 15.25 8.5H16.75C16.75 3.94365 13.0563 0.25 8.5 0.25V1.75ZM7.75 5.5V10.9H9.25V5.5H7.75ZM10.9673 8.57204L9.91892 9.62982L10.9843 10.6857L12.0327 9.62796L10.9673 8.57204ZM7.08108 9.62982L6.03269 8.57204L4.96731 9.62796L6.01569 10.6857L7.08108 9.62982ZM9.91892 9.62982C9.48848 10.0641 9.20945 10.344 8.97773 10.5301C8.75784 10.7067 8.65441 10.7363 8.59317 10.7441L8.78283 12.232C9.2311 12.1749 9.59145 11.9611 9.91697 11.6997C10.2307 11.4478 10.5787 11.095 10.9843 10.6857L9.91892 9.62982ZM6.01569 10.6857C6.42131 11.095 6.76934 11.4478 7.08303 11.6997C7.40855 11.9611 7.7689 12.1749 8.21717 12.232L8.40683 10.7441C8.34559 10.7363 8.24216 10.7067 8.02227 10.5301C7.79055 10.344 7.51152 10.0641 7.08108 9.62982L6.01569 10.6857ZM8.59317 10.7441C8.56223 10.748 8.53111 10.75 8.5 10.75V12.25C8.59447 12.25 8.68893 12.244 8.78283 12.232L8.59317 10.7441ZM8.5 10.75C8.46889 10.75 8.43777 10.748 8.40683 10.7441L8.21717 12.232C8.31107 12.244 8.40553 12.25 8.5 12.25V10.75ZM7.75 10.9V11.5H9.25V10.9H7.75Z"
                  fill="#FD504F"
                />
              </svg>
              <HeadAndDescWrapper2
                HeadTitle="Max Loss"
                SubTitle={
                  data &&
                  dollarUS(Number(data.general_statistics.max_loss).toFixed(2))
                }
                SubTitleClass="Negative"
              />
            </div>

            <div className="general_statistic_box">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.25 10.1429L5.34525 7.91007C5.89845 6.7823 7.52438 6.83738 8 8C8.47562 9.16262 10.1015 9.2177 10.6548 8.08993L11.75 5.85714M8 14.75C5.1877 14.75 3.78155 14.75 2.79581 14.0338C2.47745 13.8025 2.19748 13.5225 1.96619 13.2042C1.25 12.2184 1.25 10.8123 1.25 8C1.25 5.1877 1.25 3.78155 1.96619 2.79581C2.19748 2.47745 2.47745 2.19748 2.79581 1.96619C3.78155 1.25 5.1877 1.25 8 1.25C10.8123 1.25 12.2184 1.25 13.2042 1.96619C13.5225 2.19748 13.8025 2.47745 14.0338 2.79581C14.75 3.78155 14.75 5.1877 14.75 8C14.75 10.8123 14.75 12.2184 14.0338 13.2042C13.8025 13.5225 13.5225 13.8025 13.2042 14.0338C12.2184 14.75 10.8123 14.75 8 14.75Z"
                  stroke="#F6F6F6"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>

              <HeadAndDescWrapper2
                HeadTitle="RRR"
                SubTitle={
                  data && Number(data.general_statistics.RRR).toFixed(2)
                }
              />
            </div>
            {/* <HeadAndDescWrapper2
              HeadTitle="Martingale Count"
              SubTitle={
                Objectives &&
                Objectives["martingale"] 
                Objectives["martingale"]["martingale_count"]
              }
              SubTitleClass={
                Objectives 
                Objectives["martingale"] 
                Objectives["martingale"]["status"].toLowerCase() === "failed"
                  ? "Negative"
                  : "Positive"
              }
            /> */}
          </div>
        </div>
      </div>

      {/* <div item xs={12} md={6}>
        <Card className="card-csc"></Card>
      </div> */}
    </div>
  );
};

export default General;
